import { Route, Routes } from "react-router-dom";

import TelaPermissao from "@/Components/Base/Permissao/TelaPermissao";
import TituloCadastroScreen from "./TituloCadastroScreen";
import TituloAPagarScreen from "./TItuloAPagarScreen";
import TituloAReceberScreen, { ITituloAReceberScreenProps } from "./TituloAReceberScreen";
import TituloConsultaScreen, { ITituloConsultaScreenProps } from "./TituloConsultaScreen";
import TituloVisualizarScreen from "./TituloVisualizarScreen";
import FaturaFormScreen from "./Fatura/FaturaFormScreen";

interface ITituloScreenProps {
    consultaScreenProps?: ITituloConsultaScreenProps;
    formCadastroProps?: ITituloAReceberScreenProps;
}
export default function TituloScreen({
    consultaScreenProps,
    formCadastroProps
}:ITituloScreenProps) {
    return (
        <Routes>
            <Route
                path="/*"
                index
                element={
                    <TelaPermissao permissoes={["FinanceiroTituloListar"]}>
                        <TituloConsultaScreen {...(consultaScreenProps ?? {})} formCadastroProps={formCadastroProps ?? {}} />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/a-pagar/*"
                index
                element={
                    <TelaPermissao key={"a-pagar"} permissoes={["FinanceiroTituloListar"]}>
                        <TituloConsultaScreen key={"a-pagar"} receita={false} {...(consultaScreenProps ?? {})} formCadastroProps={formCadastroProps ?? {}} />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/a-receber/*"
                index
                element={
                    <TelaPermissao key={"areceber"} permissoes={["FinanceiroTituloListar"]}>
                        <TituloConsultaScreen key={"areceber"} receita={true} {...(consultaScreenProps ?? {})} formCadastroProps={formCadastroProps ?? {}} />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/adicionar-receber"
                element={
                    <TelaPermissao permissoes={["FinanceiroTituloInserirAReceber"]}>
                        <TituloAReceberScreen {...(formCadastroProps ?? {})} isAReceber={true} />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/adicionar-pagar"
                element={
                    <TelaPermissao permissoes={["FinanceiroTituloInserirAPagar"]}>
                        <TituloAPagarScreen {...(formCadastroProps ?? {})} isAReceber={false} />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/alterar/:codigo"
                element={
                    <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                        <TituloCadastroScreen
                            {...(formCadastroProps ?? {})}
                        />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/visualizar/:codigo"
                element={
                    <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo"]}>
                        <TituloVisualizarScreen />
                    </TelaPermissao>
                }
            ></Route>
            <Route
                path="/fatura/editar-ficha/:codigo_fatura/*"
                element={
                    <TelaPermissao permissoes={["FinanceiroTituloBuscarCodigo", "FinanceiroTituloAlterar"]}>
                        <FaturaFormScreen key={`fatura-editar-ficha-codigo`} />
                    </TelaPermissao>
                }
            ></Route>
        </Routes>
    );
}